import category from '@/api/product/product-category'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
  ...baseState,
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data
    } else {
      split(index, ',').forEach(el => {
        state.formViewDatas[el] = data[el]
      })
    }
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return category.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return category.store(data)
  },
  update(context, { id, data }) {
    return category.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await category.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id){
    return category.destroy(id)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await category.formViewModel({ params: params })
    context.commit('SET_VIEW_MODELS', {
      data: response.data,
      index: index
    })
    return Promise.resolve(response)
  },
}